export const formatTime = (milliseconds: number): string => {
  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    return `${minutes}m ${remainingSeconds}s`;
  }
  return `${remainingSeconds}s`;
};

export const getScoreMessage = (percentage: number): { title: string; message: string; emoji: string } => {
  if (percentage === 100) {
    return {
      title: 'Parfait ! 🎉',
      message: 'Vous êtes un expert en détection d\'arnaques ! Vous avez toutes les bonnes pratiques.',
      emoji: '🏆'
    };
  } else if (percentage >= 80) {
    return {
      title: 'Excellent ! 🌟',
      message: 'Très bon score ! Vous savez bien vous protéger contre la plupart des arnaques.',
      emoji: '⭐'
    };
  } else if (percentage >= 60) {
    return {
      title: 'Bien ! 👍',
      message: 'Bon travail ! Avec quelques améliorations, vous serez encore mieux protégé.',
      emoji: '✅'
    };
  } else if (percentage >= 40) {
    return {
      title: 'Peut mieux faire 📚',
      message: 'Vous avez des bases, mais soyez plus vigilant ! Relisez les conseils.',
      emoji: '📖'
    };
  } else {
    return {
      title: 'Attention ! ⚠️',
      message: 'Vous êtes vulnérable aux arnaques. Prenez le temps de lire les explications et conseils !',
      emoji: '🚨'
    };
  }
};

export const shuffleArray = <T,>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
